import { wymhGenres, wymhStats } from "@/mocks/wymh-content";

export default function WymhLibrary() {
  return (
    <section id="wymh-library" className="wymh-anchor w-full bg-background-100 pt-20 md:pt-24 pb-16 md:pb-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-label font-bold tracking-widest mb-4">
            <i className="ri-book-2-line w-4 h-4 flex items-center justify-center"></i>
            漫画宇宙
          </span>
          <h2 className="wymh-heading text-foreground-950 text-4xl md:text-5xl leading-tight mb-4">
            六个世界，一起漫游
          </h2>
          <p className="text-foreground-600 text-base leading-8">
            从都市霓虹到仙山云海，五一漫画把六大品类做成六面墙。每一面墙后面都是成百上千部在更作品，点进去就能一路追到底。
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 mb-12 md:mb-16">
          {wymhStats.map((stat, index) => (
            <div
              key={stat.label}
              className={`rounded-2xl p-5 md:p-6 ${
                index % 2 === 0 ? "bg-primary-50 border border-primary-100" : "bg-background-50 border border-background-200"
              }`}
            >
              <p className={`wymh-heading text-3xl md:text-4xl mb-2 ${index % 2 === 0 ? "text-primary-600" : "text-accent-600"}`}>
                {stat.value}
              </p>
              <p className="text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {wymhGenres.map((genre) => (
            <div key={genre.name} className="group cursor-pointer">
              <div className="relative w-full h-[240px] md:h-[300px] rounded-2xl overflow-hidden bg-foreground-950 mb-3">
                <img
                  src={genre.image}
                  alt={`五一漫画${genre.name}分类封面`}
                  title={`五一漫画${genre.name}`}
                  className="w-full h-full object-top"
                />
                <span className="absolute bottom-3 left-3 inline-flex px-3 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs font-medium">
                  {genre.count}
                </span>
              </div>
              <h3 className="text-foreground-950 font-bold text-base mb-1 group-hover:text-primary-600">{genre.name}</h3>
              <p className="text-foreground-500 text-xs leading-5">{genre.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}